import React, { useEffect, useState } from "react";
import { teamLeagueInfoUrl } from "../../../utils/generalLiveCenter";
import { loadStyles } from "../../../utils/cssLoader";

const BasketballStandingTable = ({ ServerData,
  loadCSS = true,
  dataClient = false,
  title,
  sport = "basketball",
  websiteBaseUrl,
  dataPath,

}) => {
  const [clientData, setClientData] = useState(null);
  const data = dataClient ? clientData : ServerData;

  useEffect(() => {
    if (!dataClient) return;
    const container = document?.querySelector(".microservice-cont");
    const raw = container?.getAttribute("data-listingdata");
    if (!raw) return;

    try {
      const parsed = JSON.parse(raw)?.data;
      setClientData(parsed || null);
    } catch (err) {
      console.error("Failed to parse data-listingdata:", err);
    }
  }, [dataClient]);

  useEffect(() => {
    if (loadCSS === "true") {
      loadStyles("leaguestandings");
    }
  }, [loadCSS]);
  return (
    <div className="global_table standing_table rugby">
      {title && <h1>{title}</h1>}
      <table>
        <thead>
          <tr>
            <th>#</th>
            <th>
              <span>Teams</span>
            </th>
            <th>P</th>
            <th>W</th>
            <th>L</th>
            <th>STR</th>
            <th>GB</th>
            <th>PCT</th>
            <th>FORM</th>
          </tr>
        </thead>
        <tbody>
          {data?.data?.table?.length &&
            data?.data?.table.map((t, index) => (
              <tr key={index}>
                <td>{t?.pc}</td>
                <td>
                  <a
                    href={teamLeagueInfoUrl({
                      dataClient,
                      websiteBaseUrl,
                      dataPath,
                      category: "team",
                      sport,
                      name: t?.team?.nm,
                      id: t?.team?.id,
                    })}
                  >
                    {t?.team?.nm}</a></td>
                <td>{t?.pl}</td>
                <td>{t?.wo}</td>
                <td>{t?.lo}</td>
                <td>{t?.sc}</td>
                <td>{t?.df}</td>
                <td>{t?.cc}</td>
                <td>
                  <ul className="prev_match_status">
                    {t.lfm.map((w, index) => (
                      <li key={index} className={`${w === "W" ? "win" : "loss"}`}>
                        {w}
                      </li>
                    ))}
                  </ul>
                </td>
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
};

export default BasketballStandingTable;
